import React, { Component } from 'react';
import PropTypes from 'prop-types';

class  XTbody extends Component{

    constructor(props) {
        super(props)
        this.props=props;
    }

    render(){
        const {
            children,
            className,
            eleRef,
        } = this.props;


        return(
            <>
                <tbody ref={eleRef} className={className}    >
                    {children}
                </tbody>
            </>
        )
    }
}

XTbody.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    eleRef: PropTypes.any,
};

XTbody.defaultProps = {};

export default  XTbody;

